import instanceAxios from "../../../../../utils/axiosInstance";

export const searchDocuments = (filters) =>
  instanceAxios.post(`/api/documents/search`, filters);

export const getDetailsForTransfert = (id, sourceType) =>
  instanceAxios.get(`/api/${sourceType}/DetailsForTransfert/${id}`);

export const executeTransfert = (payload) =>
  instanceAxios.post('/api/transfer/transfert-documents', payload);

export const getListeClients = () =>
  instanceAxios.get(`/api/Clients`);

export const getListeTiers = (mode) => {
  switch (mode) {
    case "achat":
      return instanceAxios.get("/api/Suppliers");

    case "vente":
      return instanceAxios.get("/api/Clients");

    default:
      throw new Error(`Mode invalide : ${mode}. Valeurs autorisées : 'achat' ou 'vente'.`);
  }
};
export const getTransferInfos = async (ligneIds, sourceType, docId) => {
    const response = await getDetailsForTransfert(docId, sourceType);
    console.log("DetailsForTransfert :", response.data);   // à retirer après vérification

    const data = response.data;
    const lignes = Array.isArray(data) ? data
        : Array.isArray(data?.details) ? data.details
        : Array.isArray(data?.data) ? data.data
        : Array.isArray(data?.$values) ? data.$values
        : [];
console.log("lignes :", lignes);
    // ne garder que les lignes demandées
    return lignes.filter(l => ligneIds.includes(l.ligneId ?? l.id));
};